import styled from "styled-components";

const Field = styled.div`
  margin-bottom: 1em;
  pointer-events: none;
`;

export default Field;
